var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcLocationGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3709 4.98854C7.64352 2.33715 11.7453 2.33715 14.0179 4.98854C15.8458 7.12105 15.8458 10.2678 14.0179 12.4003L10.5929 16.3962C10.3495 16.6801 10.2278 16.8221 10.0939 16.8953C9.84493 17.0313 9.54393 17.0313 9.29493 16.8953C9.16101 16.8221 9.03934 16.6801 8.79593 16.3962L5.3709 12.4003C3.54303 10.2678 3.54303 7.12105 5.3709 4.98854Z",
    stroke: "#A6A6A7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3607 8.27751C11.3607 9.19801 10.6145 9.94417 9.69401 9.94417C8.77351 9.94417 8.02734 9.19801 8.02734 8.27751C8.02734 7.35703 8.77351 6.61084 9.69401 6.61084C10.6145 6.61084 11.3607 7.35703 11.3607 8.27751Z",
    stroke: "#A6A6A7",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationGrey);
export default __webpack_public_path__ + "static/media/ic-location-grey.128883f9e01dc1b50594d94e1f25e6b3.svg";
export { ForwardRef as ReactComponent };